import { api } from '@/f1/service';
import codes from '@/f1/codes';
import reg from '@/f1/reg';
import { saveAs } from 'file-saver';
import moment from 'moment-timezone'
import { VclFacebook } from 'vue-content-loading';
import htmlViewer from '../Detect.Viewer.i18n';

//restful api
// import { wmds_v2 as ws } from '@/f1/service/api'

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components : { VclFacebook, htmlViewer },
  data : () => {
    return {
      row_id : -1,
      row_position : -1,
      move_function : undefined,
      reg,
      loading : false,
      codes : codes,
      thumbnail_size: '100%',
      confirm: false,
      add: false,
      model : {},
      url_tree : {},
      thumbnail : '',
      row_count : 0,
    }
  },
  computed: {
    depth() { return this.model.depth+1; },
    image() { return this.model.thumbnail && 'data:image/png;base64,' + this.model.thumbnail || ''; }
  },
  methods: {
    clear() {
      this.move_function ? clearInterval(this.move_function) : ''; this.move_function = undefined
      console.log('clear therad detail')
    },
    heilith() {
      try {
        // if(this.row_id < 0) { return alert("no have matched, check first the page is dynamic") }
        let target = document.getElementById('target_'+this.row_id + 1)
        if(target == null) {
          var pattern = this.model.ucode.split('/');
          var text = pattern[pattern.length-1];
          var inputText = document.getElementById("scroll_panel");
          var innerHTML = inputText.innerHTML;
          var index = innerHTML.indexOf(text);
          if (index >= 0) { 
          innerHTML = innerHTML.substring(0,index) + "<span class='highlight'>" + 
          innerHTML.substring(index,index+text.length) + 
          "</span>" + innerHTML.substring(index + text.length);
          inputText.innerHTML = innerHTML;
          }
          return;
        }
        let panel = document.getElementById('scroll_panel')
        this.row_position = this.row_position < 0 ? panel.scrollTop + target.offsetTop : this.row_position
        // console.log('gap', gap, 'panel.scrollTop', panel.scrollTop, 'this.row_position', this.row_position)

        let move = function(row_position = this.row_position, func = this.clear()) {
          // console.log('move', panel.scrollTop, row_position)
          if (panel.scrollTop < row_position + 50 && panel.scrollTop > row_position - 300) { func() }
          else { panel.scrollTop += 100 }
        }
        panel.scrollTop = 0
        this.move_function = setInterval(() => move(this.row_position, this.clear), 5);
        setTimeout(() => { clearInterval(this.move_function); this.move_function = undefined }, 5 * 1000) // force clear after 5 sec
      } catch (e) { console.log(e) }
    },
    change(content) {
      window.hey = document.fromTextArea(document.getElementById('abcd'), {
        lineNumbers: true,
          mode:"htmlmixed",
          lineWrapping:true
      });
      console.log("changed")
      this.model = Object.assign({}, this.model, { content : content })
    },
    // selecting() { try { this.heilith() } catch (e) { console.log(e) } },
    copy(x, type) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value = x;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i(`${type} ` + `${i18n_data._i18n_info.copy[this.i18n]}`)
      } catch (e) { console.log(e); this.$toastr.i(`${i18n_data._i18n_error.copy_failed[this.i18n]}`) }
    },
    save_rs() {
      let data = (this.model.data.split('\n') || [])
      if(!data.length) { this.$toastr.i(`${i18n_toastr._i18n_info.detected_info[this.i18n]}`); return; }
      let blob = new Blob(data, {type: "text/plain;charset=utf-8"});
      let ts = moment(this.model.detected_at).format("YYYY-MM-DD")
      saveAs(blob, `${this.model.domain}_${ts}_detect.log`);
    },
    toggle_thumbnail() { this.thumbnail_size = this.thumbnail_size == '100%' ? '200%' : '100%'; },
    list() { this.$router.push({ name: 'wmds_detect'}); },
    async remove() {
      try {
        let rs = await api.wmds.WMDS_Call('detect', 'delete', { id : this.model.id })
        //let rs = await ws.detect.delete({ id : this.model.id })
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.remove_failed[this.i18n]}`) }
        this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`);
        this.$parent.$emit('refresh');
        this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) , this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; return; }
      else { this.add = false; }
      try{
        this.loading = true
        let rs = await api.wmds.WMDS_Call('detect', 'detail', { id : id })
        //Todo: 확인완료
        // let rs = await ws.detect.detail({ id : id })
        if(rs.error) { return this.$toastr.e(`${i18n_toastr._i18n_error.load_failed[this.i18n]}`) }

        this.model = Object.assign({ group: {} }, this.model, rs.body, JSON.parse(rs.body.detail_data))
        this.model.url_tree.reverse()
        this.$parent.$emit('loading', false)
        this.loading = false

      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); }, },
  created: function() {   console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}